import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useWillMount } from '../../hooks';

const Portal = ({ children }) => {
  const element = useRef();

  useWillMount(() => {
    element.current = document.createElement('div');
    document.body.appendChild(element.current);
  });

  useEffect(() => () => document.body.removeChild(element.current), []);

  return ReactDOM.createPortal(children, element.current);
};

Portal.propTypes = {
  children: PropTypes.node,
};

Portal.defaultProps = {
  children: null,
};

export default Portal;
